<style lang="sass" scoped>

</style>

<template lang="pug">
div.my-2
  v-btn(text @click='uploadDotAllDialog = true') Importar .all
  v-dialog(v-model='uploadDotAllDialog' width='400px')
    v-card
      v-card-title
        | Importar .all
        v-spacer
          v-btn(text @click='uploadDotAllDialog = false')
            v-icon mdi-close
      v-card-text
        v-form(ref='form' :novalidate='false')
          v-text-field(v-model='newEvent.event_id' label='Id do Evento (GD7)' :rules='inputRules')
          h4.my-4 Selecione um arquivo .all
          input(type='file' accept='.all' @change='onFilePicked')
      v-card-actions
        v-btn(@click='uploadDotAll()' :loading='sendingFile') Enviar
      v-snackbar(v-model='eventSentSnackbar')
        div Arquivo enviado!
        v-btn(icon @click='eventSentSnackbar = false')
          v-icon mdi-close
      v-snackbar(v-model='eventSentErrorSnackbar')
        div Erro ao enviar arquivo!
        v-btn(icon @click='eventSentErrorSnackbar = false')
          v-icon mdi-close
  v-spacer
</template>

<script>
import utils from '../../utils/requests'

export default {
  props: {
  },
  data () {
    return {
      uploadDotAllDialog: false,
      sendingFile: false,
      eventSentSnackbar: false,
      eventSentErrorSnackbar: false,
      inputRules: [
        v => !!v || 'Este campo é obrigatório'
      ],
      newEvent: {
        event_id: '',
        body: null
      }
    }
  },
  mounted () {
  },
  methods: {
    uploadDotAll () {
      if (this.$refs.form.validate()) {
        this.sendingFile = true
        const data = {
          event_id: this.newEvent.event_id,
          body: this.newEvent.body
        }
        utils.postAPI('/event/upload_dot_all_file', data).then(res => {
          this.sendingFile = false
          this.uploadDotAllDialog = false
          this.eventSentSnackbar = true
        }).catch(err => {
          console.log(err)
          this.sendingFile = false
          this.uploadDotAllDialog = false
          this.eventSentErrorSnackbar = true
        })
      }
    },
    onFilePicked (event) {
      const files = event.target.files

      const fileReader = new FileReader()

      fileReader.onload = (res) => {
        console.log(res.target.result)
        this.newEvent.body = res.target.result
      }

      fileReader.readAsText(files[0])
    }
  }
}
</script>
